import { Injectable } from '@angular/core';
import { APP_CONST } from '../../app.const';
import { RequestService } from '../../libraries/http/request.service';

@Injectable()
export class UserRestService {
  baseURL = `${APP_CONST.API_MASTER}/admin/users`;
  request = this._request.new(this.baseURL);

  constructor(private _request: RequestService) {}

  create(payload: any) {
    return this.request.post<any>(``, payload);
  }

  findAll(queryParams: any = {}) {
    return this.request.get<any>(``, { params: queryParams });
  }

  load(userId: string) {
    return this.request.get<any>(`${userId}`);
  }

  delete(userId: string) {
    return this.request.delete<any>(`${userId}`);
  }

  update(userId: string, payload: any) {
    return this.request.put<any>(`/profile/${userId}`, payload);
  }

  reset(userId: string, payload: any) {
    return this.request.put<any>(`/password/${userId}`, payload);
  }

  changePassword(userId: string, payload) {
    return this.request.put<any>(`/change-password/${userId}`, payload);
  }

  updateProfileDealer(userId: string, payload) {
    const adminDealer = `${APP_CONST.API_MASTER}/admin/dealers`;
    const adminRequest = this._request.new(adminDealer);
    return adminRequest.put<any>(`/profile/${userId}`, payload);
  }

  getDealerByUser(userId: string) {
    const adminDealer = `${APP_CONST.API_MASTER}/admin/dealers`;
    const adminRequest = this._request.new(adminDealer);
    return adminRequest.get<any>(`/profile/${userId}`);
  }

  getDealershipRoles(queryParams: any = {}) {
    return this.request.get<any>(`/dealership-roles`, { params: queryParams });
  }
}
